const { default: parentApi } = require("store/parentApi");

const importedQuestionsApi = parentApi.injectEndpoints({
  endpoints: (build) => ({
    getImportedQuestions: build.query({
      query: (body) => ({
        url: "/importedQuestions/getImportedQuestions",
        method: "POST",
        body,
      }),
      providesTags: ["importedQuestions"],
    }),
    getImportedQuestion: build.query({
      query: (body) => ({
        url: "/importedQuestions/getImportedQuestion",
        method: "POST",
        body,
      }),
      providesTags: ["importedQuestionDetail"],
    }),
  }),
});

export const { useGetImportedQuestionsQuery, useGetImportedQuestionQuery } =
  importedQuestionsApi;
